<div class="discovery-pages-container">
  <div class="header">
    <h1>Discovery Pages Management</h1>
    <p class="subtitle">View and manage scraped content data from ProjectDiscoveryPages</p>
  </div>

  <!-- Loading State -->
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading discovery pages...</p>
    </div>
  }

  <!-- Accordion List -->
  @if (!loading) {
    <div class="accordion-container">
      <div class="list-header">
        <div class="list-info">
          <span>Total Pages: {{ pages.length }}</span>
          <span>Page {{ currentPage }} of {{ totalPages }}</span>
        </div>
      </div>

      <mat-accordion class="discovery-accordion">
        @for (page of pages; track page.id) {
          <mat-expansion-panel class="discovery-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-header-content">
                  <div class="panel-header-main">
                    <span class="page-id">#{{ page.id }}</span>
                    <span class="page-domain">{{ page.domain }}</span>
                  </div>
                  <div class="panel-header-meta">
                    <span class="badge">{{ getPagesUrls(page).length }} URLs</span>
                    <span class="badge">{{ getPagesTextCount(page) }} with content</span>
                    <span class="date-badge">{{ formatDate(page.last_fetched_at) }}</span>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- Panel Content (Expanded) -->
            <div class="panel-content">
              <!-- Summary Section -->
              <div class="content-section">
                <h3 class="section-title">Summary</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">ID:</span>
                    <span class="info-value">{{ page.id }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Domain:</span>
                    <span class="info-value">{{ page.domain }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Total URLs:</span>
                    <span class="info-value">{{ getPagesUrls(page).length }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">URLs with Content:</span>
                    <span class="info-value">{{ getPagesTextCount(page) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Created Date:</span>
                    <span class="info-value">{{ formatDate(page.last_fetched_at) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Updated Date:</span>
                    <span class="info-value">{{ formatDate(page.updated_at) }}</span>
                  </div>
                </div>
              </div>

              <!-- Content Section -->
              @if (hasPagesText(page)) {
                <div class="content-section">
                  <div class="section-header">
                    <h3 class="section-title">Scraped Content</h3>
                    <button 
                      mat-raised-button 
                      color="primary"
                      matTooltip="Copy all content"
                      (click)="copyAllContent(page)">
                      <mat-icon>content_copy</mat-icon>
                      Copy All Content
                    </button>
                  </div>

                  <div class="content-list">
                    @for (url of getPagesUrls(page); track url) {
                      <div class="content-item">
                        <div class="content-item-header">
                          <div class="content-url">
                            <mat-icon>link</mat-icon>
                            <span>{{ url }}</span>
                          </div>
                          @if (hasPageContent(page, url)) {
                            <button 
                              mat-icon-button 
                              matTooltip="Copy this page content"
                              (click)="copyPageContent(page, url)"
                              class="copy-button-small">
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          }
                        </div>
                        @if (hasPageContent(page, url)) {
                          <div class="content-text">{{ page.pages_text![url] }}</div>
                        } @else {
                          <div class="content-text no-content">No content available for this URL</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div class="content-section">
                  <div class="no-content-message">
                    <mat-icon>info</mat-icon>
                    <p>No scraped content available for this domain.</p>
                  </div>
                </div>
              }

              <!-- Actions Section -->
              <div class="actions-section">
                <button 
                  mat-raised-button 
                  color="warn"
                  matTooltip="Delete this discovery page"
                  (click)="deletePage(page)">
                  <mat-icon>delete</mat-icon>
                  Delete
                </button>
              </div>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>

      <!-- Pagination -->
      @if (totalPages > 1) {
        <div class="pagination">
          <button 
            mat-button 
            [disabled]="currentPage === 1"
            (click)="goToPage(currentPage - 1)">
            <mat-icon>chevron_left</mat-icon>
            Previous
          </button>
          <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
          <button 
            mat-button 
            [disabled]="currentPage === totalPages"
            (click)="goToPage(currentPage + 1)">
            Next
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
